import { getHublet, getHsVarsRendererContext } from 'video-embed/utils/cms';
import { isQa } from 'video-embed/utils/env';
import { parseQueryParams } from 'video-embed/utils/url';
function setupPlaceholder(portalId, videoId) {
  const placeholderEl = document.querySelector('#player_wrapper .hs-video-widget');
  if (!placeholderEl) {
    console.warn('Could not find placeholder el');
    return null;
  }
  if (placeholderEl.querySelector('img[data-hsv-id]') || placeholderEl.querySelector('iframe[data-hsv-id]')) {
    // if used with the renderer, the placeholder and image will already be present
    return placeholderEl;
  }
  const placeholderImgEl = document.createElement('img');
  const appDomain = isQa() ? 'hubapiqa.com' : 'hubapi.com';
  const hubletSuffix = getHublet() ? `-${getHublet()}` : '';
  placeholderImgEl.src = `https://api${hubletSuffix}.${appDomain}/video/v1/public/${videoId}/poster?portalId=${portalId}`;
  placeholderImgEl.setAttribute('data-hsv-portal-id', String(portalId));
  placeholderImgEl.setAttribute('data-hsv-id', String(videoId));
  placeholderEl.appendChild(placeholderImgEl);
  return placeholderEl;
}
function parseVideoIdFromPath() {
  // only allow loading the experimental static app route on local / QA domains for now
  if (window.location.hostname === 'play.hubspotvideo.com') {
    return null;
  }
  const pathParts = window.location.pathname.substring(1).split('/');
  if (pathParts.length === 3 && pathParts[0] === 'share' && pathParts[1] === 'hubspotvideo' && Number(pathParts[2])) {
    return Number(pathParts[2]);
  }
  return null;
}
function setupPlayer(player) {
  player.on('videoLoaded', () => {
    const {
      video
    } = player;
    if (!video) {
      return;
    }
    console.log('Video loaded', video);
    const videoTitle = video.altText || video.title;
    document.body.classList.add('video-loaded');
    document.title = `${videoTitle} | HubSpot Video`;
    const titleEl = document.getElementById('video_title');
    titleEl.textContent = videoTitle;
  });
}
function renderSharePage() {
  const {
    getPlayers,
    renderPlayer
  } = window.hsVideoApi;
  const queryParams = parseQueryParams();
  const videoId = parseVideoIdFromPath();
  if (!videoId) {
    console.warn('Unrecognized path');
    return;
  }
  let portalId;
  let placeholderEl;
  const hsVars = getHsVarsRendererContext();
  document.body.style.setProperty('position', 'absolute', 'important');
  if (hsVars && hsVars.portal_id && videoId) {
    // served on a customer domain via deployed renderer, which injects `hsVars` context
    portalId = hsVars.portal_id;
    placeholderEl = setupPlaceholder(hsVars.portal_id, videoId);
  } else if (Number(queryParams.portalId) && videoId) {
    // static app test route, depends on ?portalId= query param
    portalId = Number(queryParams.portalId);
    window.hsVars = window.hsVars || {
      portal_id: portalId,
      page_id: 0
    };
    placeholderEl = setupPlaceholder(portalId, Number(videoId));
  } else {
    console.warn('Missing portalId context, use the ?portalId= query param if running as static app');
    return;
  }
  let player;
  if (getPlayers().length) {
    // for renderer, player should be created from placeholder automatically
    player = getPlayers()[0];
  } else if (placeholderEl) {
    player = renderPlayer(placeholderEl, {
      portalId,
      id: videoId,
      renderContext: 'share-page'
    });
  }
  if (player) {
    setupPlayer(player);
  } else {
    console.warn('renderPlayer did not return player');
  }
}
window._hsVideoReady = window._hsVideoReady || [];
window._hsVideoReady.push(renderSharePage);